module.exports = __webpack_public_path__ + "img/ilawyer_favicon.80e70cc9.svg";